import React from 'react'
import './oscillation.css'
const Oscillation = () => {
  return (
    <>
    <div className='oscillation-container'>
    <div className="ratio ratio-1x1">
    <iframe
            className='oscillation'
            src="https://cymatics.live/website/source/cymatics/examples/frequency-view.html"
            title="YouTube video"
            allowfullscreen
        ></iframe>
      </div>
    </div>
    </>
  )
}

export default Oscillation